import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/app/Header";
import { Clock, ArrowRight } from "lucide-react";

const ICONS = {
  osteopatia: "🌿",
  fisioterapia: "💧",
  riabilitazione: "🪴",
  cervicale: "🍃",
  schiena: "🌾",
  sportivo: "🏃",
};

export default function Treatments() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-5xl mx-auto px-5 md:px-8 pt-10 md:pt-14 pb-20">
        <div className="overline mb-3">I trattamenti</div>
        <h1 className="font-display text-3xl sm:text-4xl font-light text-[#1A231F]">Scopri come posso aiutarti</h1>
        <p className="mt-3 text-[#5C7066] max-w-2xl">Ogni percorso parte da una valutazione attenta. Qui di seguito trovi una guida semplice ai trattamenti che propongo.</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {services.map((svc, i) => (
            <div key={svc.id} data-testid={`service-card-${svc.id}`} className={`card-soft p-6 fade-up d${(i%4)+1}`}>
              <div className="text-2xl mb-2" aria-hidden>{ICONS[svc.id] || "✶"}</div>
              <h3 className="font-display text-xl text-[#1A231F]">{svc.title}</h3>
              <p className="text-sm text-[#5C7066] mt-2 leading-relaxed">{svc.description}</p>
              <div className="mt-4 pt-4 border-t border-[#E0E5E2]">
                <div className="text-xs uppercase tracking-wider text-[#2D4A3E] font-medium mb-1">Indicazioni</div>
                <div className="text-sm text-[#5C7066]">{svc.indications}</div>
              </div>
              <div className="mt-4 flex items-center gap-1 text-sm text-[#2D4A3E]">
                <Clock size={14} /> Durata: {svc.duration} minuti
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <Link to="/prenota" data-testid="treatments-cta-prenota" className="inline-flex items-center gap-2 h-14 px-7 rounded-xl bg-[#2D4A3E] text-white font-medium hover:bg-[#1A2F26] transition-colors">
            Prenota ora <ArrowRight size={18} />
          </Link>
        </div>
      </main>
    </div>
  );
}
